var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"simple-page"},[(_vm.heroImage)?_c('header',[_c('div',{staticClass:"hero-image",style:(`background-image: url(${_vm.heroImage})`)},[_c('img',{attrs:{"src":_vm.heroImage}})]),_c('h1',[_vm._v(_vm._s(_vm.$dt(_vm.title)))])]):(_vm.title)?_c('h1',[_vm._v(_vm._s(_vm.$dt(_vm.title)))]):_vm._e(),_vm._l((_vm.sections),function(section){return _c('section',{class:[
      section.box_type ? `boxed-${section.box_type}` : null,
      {
        boxed: section.box_type,
      },
    ]},[(section.title)?_c('h2',[_vm._v(_vm._s(_vm.$dt(section.title)))]):_vm._e(),_vm._l((section.content),function(block){return _c('content-block',{attrs:{"content":block}})})],2)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }